/**
 * Format a number with locale-safe thousands separators.
 * Always uses 'en-US' format (comma as thousands separator)
 * regardless of browser locale, ensuring ¥13,662 not ¥13.662.
 */
export function formatNumber(n: number): string {
  return n.toLocaleString('en-US');
}
